import { render, staticRenderFns } from "./BaseProductTileImage.vue?vue&type=template&id=ae9c0c28&"
import script from "./BaseProductTileImage.vue?vue&type=script&lang=js&"
export * from "./BaseProductTileImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9c0c28')) {
      api.createRecord('ae9c0c28', component.options)
    } else {
      api.reload('ae9c0c28', component.options)
    }
    module.hot.accept("./BaseProductTileImage.vue?vue&type=template&id=ae9c0c28&", function () {
      api.rerender('ae9c0c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductTileImage.vue"
export default component.exports